import { createFileRoute } from '@tanstack/react-router';

import { client } from '@@api/client';
import config from '@@config';
import { requireRoles } from '@@router/guards';
import { handleLoaderError } from '@@router/handleLoaderError';

import { Layout } from './-components/Layout';

// No layout route for the section: it would show an empty page at `/maintenancenotes`
export const Route = createFileRoute('/_authenticated/maintenancenotes/$id')({
    context: ({ params }) => ({
        maintenanceNoteQuery: client.releasenotes.maintenanceNotes.get.queryOptions(
            { params: { id: Number(params.id) } },
            { refetchOnWindowFocus: false },
        ),
    }),
    beforeLoad: requireRoles(config.navigation.maintenancenotes.authorize),
    loader: ({ context }) =>
        context.queryClient
            .query({ ...context.maintenanceNoteQuery, staleTime: 'static' })
            .catch(handleLoaderError),
    component: Layout,
});
